module.exports = __webpack_public_path__ + "img/pump.baa97964.svg";